'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _components = require('../../components');
var _PropertyListBottomBlock = require('./PropertyListBottomBlock.scss');var styles = _interopRequireWildcard(_PropertyListBottomBlock);
var _findMappedLocalization = require('../../utils/cities/findMappedLocalization');
var _findNeighborhoodNames = require('../../utils/neighborhoods/findNeighborhoodNames');var _findNeighborhoodNames2 = _interopRequireDefault(_findNeighborhoodNames);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PropertyListBottomBlock = function (_Component) {_inherits(PropertyListBottomBlock, _Component);function PropertyListBottomBlock() {var _temp, _this, _ret;_classCallCheck(this, PropertyListBottomBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    numberOfParagraphs = 9, _this.
    mapReference = new Array(_this.numberOfParagraphs).fill(''), _this.
    composeCitiesDescriptionText = function (cityKey) {return (
        _this.mapReference.map(function (item, idx) {return (
            _this.props.translateCities(cityKey, 'p' + (idx + 1)));}).
        join('\n'));}, _this.

    composeProjectsDescriptionText = function (key) {return (
        _this.mapReference.map(function (item, idx) {return (
            _this.props.translateProjects(key, 'p' + (idx + 1)));}).
        join('\n'));}, _this.

    handleNeighbourhoodClick = function (neighborhood) {
      var hasTags = _this.props.locationSearch.tags && _this.props.locationSearch.tags.length === 1;
      var updated = {
        locationSearch: Object.assign({},
        _this.props.locationSearch, {
          tags: hasTags ?
          [_this.props.locationSearch.tags[0], neighborhood] :
          undefined,
          key: hasTags ? neighborhood : undefined,
          isCity: false,
          isNeighborhood: true,
          map: {},
          en: Object.assign({},
          _this.props.locationSearch.en, {
            neighborhood: neighborhood,
            street_name: undefined,
            house_number: undefined }) }) };




      _this.props.updateRoute(updated);
    }, _this.




































































    renderSaveSearchBlock = function (hasProperties, isLastPage) {return hasProperties && isLastPage &&
      _react2.default.createElement(_components.PropertiesListSaveSearchBlock, {
        rootTranslate: _this.props.translate,
        hasProperties: hasProperties,
        saveSearchLocation: _this.props.saveSearchLocation });}, _temp), _possibleConstructorReturn(_this, _ret);} // eslint-disable-line react/sort-comp
  PropertyListBottomBlock.prototype.shouldRenderCityDescription = function shouldRenderCityDescription(cityKey, location, optionType) {if (!cityKey) {return false;}switch (location) {case 'homes':{if (optionType === 'buy') {var res = false;try {var trans = this.props.translateCities(cityKey);res = cityKey !== trans();} catch (err) {// eslint-disable-line
            }return res;}return false;}default:return false;}};PropertyListBottomBlock.prototype.renderCityDescriptionSection = function renderCityDescriptionSection(cityKey, location, optionType) {return this.shouldRenderCityDescription(cityKey, location, optionType) && _react2.default.createElement('div', { className: styles.citiesDescription }, _react2.default.createElement(_components.ShowMore, { text: this.composeCitiesDescriptionText(cityKey), heightLimit: 70, moreButtonText: this.props.translate('SEOsearch', 'showMore'), customStyles: styles.citiesContent }));};PropertyListBottomBlock.prototype.renderProjectDescriptionSection = function renderProjectDescriptionSection() {return _react2.default.createElement('div', { className: styles.citiesDescription }, _react2.default.createElement(_components.ShowMore, { text: this.composeProjectsDescriptionText('description'), heightLimit: 50, moreButtonText: this.props.translate('SEOsearch', 'showMore'), customStyles: styles.citiesContent }));};PropertyListBottomBlock.prototype.renderCityNeighborhoods = function renderCityNeighborhoods(neighborhoods, neighborhoodsHeader) {return neighborhoods && neighborhoods.length && _react2.default.createElement(_components.CollapsibleGrid, { data: neighborhoods, header: neighborhoodsHeader, heightLimit: 3, moreButtonText: this.props.translate('SEOsearch', 'showMore').toString(), locale: this.props.locale, handleClick: this.handleNeighbourhoodClick });};PropertyListBottomBlock.prototype.

  render = function render() {var _this2 = this;var _props =













    this.props,routeLocation = _props.routeLocation,propertyType = _props.propertyType,optionType = _props.optionType,locationSearch = _props.locationSearch,loadedPropertiesCount = _props.loadedPropertiesCount,isSinglePropertyType = _props.isSinglePropertyType,loading = _props.loading,translate = _props.translate,locale = _props.locale,hasNoFilters = _props.hasNoFilters,propertiesQuantity = _props.propertiesQuantity,projectsQuantity = _props.projectsQuantity;

    var cityKey = (0, _findMappedLocalization.getCityKey)(locationSearch);
    var neighborhoods = (0, _findNeighborhoodNames2.default)(cityKey, locale, routeLocation, optionType);

    var isScrollTopShown = this.props.componentHeight < this.props.propertyHeight * loadedPropertiesCount;

    var isProjects = routeLocation === 'projects';
    var searchTargetTitle = isProjects ? 'projects' : 'realEstateApartments';

    var option = propertyType && isSinglePropertyType ?
    translate('propertyTypes', propertyType) :
    translate('SEOsearch', searchTargetTitle);

    var quantity = (propertiesQuantity || 0) + (projectsQuantity || 0);

    var description = translate('found') + ' ' + quantity + ' ' + option + ' ' + (optionType ? translate('propertyDetails', 'SEOTitle', optionType) : '');
    var location = locationSearch && (locationSearch[locale] || locationSearch.en);

    var localisedCity = '';

    if (location && location.city_name) {
      var neighborhood = location.neighborhood && location.neighborhood !== location.city_name ?
      location.neighborhood + ', ' :
      '';
      localisedCity = (0, _findMappedLocalization.getMappedLocation)(locationSearch, locale);
      var fullLocation = '' + neighborhood + localisedCity;
      description += ' ' + (0, _findMappedLocalization.formatLocation)(fullLocation, translate, locale);
    }

    var translatedCity = (0, _findMappedLocalization.formatLocation)(localisedCity, translate, locale);
    if (cityKey && !translatedCity) {
      console.error('Please add [' + locale + '] localisation to city "' + cityKey + '"');
    }
    var neighborhoodsHeader = this.props.translate('neighborhoods') + ' ' + (translatedCity || '');

    return (
      _react2.default.createElement('div', { className: styles.listBottomBlock },

        isScrollTopShown &&
        _react2.default.createElement('div', { className: styles.buttonLine },
          _react2.default.createElement('button', {
              className: 'buttonLoad',
              style: { display: this.props.isLastPage ? 'none' : 'inline-block' },
              onClick: function onClick() {return _this2.props.loadMore({ type: routeLocation, is_mobile: _this2.props.isMobile });},
              disabled: loading },

            _react2.default.createElement('span', { className: 'button-text' },
              loading ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) : '' +
              this.props.translate('loadMore'))),


          _react2.default.createElement(_components.OMUpButton, { scrollTop: this.props.scrollUp })),




        !isProjects && this.renderSaveSearchBlock(!!this.props.loadedPropertiesCount, this.props.isLastPage),

        _react2.default.createElement('div', { className: styles.listDescription },
          _react2.default.createElement('span', { className: styles.title }, this.props.transformDataForTitle()),
          _react2.default.createElement('span', { className: styles.description }, description)),

        locationSearch && locationSearch.isCity && hasNoFilters &&
        this.renderCityDescriptionSection(cityKey, routeLocation, optionType),

        routeLocation === 'projects' && this.renderProjectDescriptionSection(),

        cityKey && this.renderCityNeighborhoods(neighborhoods, neighborhoodsHeader) || null));


  };return PropertyListBottomBlock;}(_react.Component);exports.default = PropertyListBottomBlock;


PropertyListBottomBlock.propTypes = {
  updateRoute: _propTypes2.default.func,
  routeLocation: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  isSinglePropertyType: _propTypes2.default.bool,
  optionType: _propTypes2.default.string,
  locationSearch: _propTypes2.default.object,
  hasNoFilters: _propTypes2.default.bool,

  loadedPropertiesCount: _propTypes2.default.number,
  propertiesQuantity: _propTypes2.default.number,
  projectsQuantity: _propTypes2.default.number,
  loading: _propTypes2.default.bool,
  locale: _propTypes2.default.string,

  isLastPage: _propTypes2.default.bool,
  componentHeight: _propTypes2.default.number,
  propertyHeight: _propTypes2.default.number,

  translate: _propTypes2.default.func,
  translateCities: _propTypes2.default.func,
  translateProjects: _propTypes2.default.func,
  transformDataForTitle: _propTypes2.default.func,
  saveSearchLocation: _propTypes2.default.func,
  loadMore: _propTypes2.default.func,
  scrollUp: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyListBottomBlock/PropertyListBottomBlock.js
// module id = 2864
// module chunks = 0